import { useQueryClient } from '@tanstack/react-query';

export function useInvalidateCache() {
  const qc = useQueryClient();

  return {
    invalidateFishTypes: () => qc.invalidateQueries({ queryKey: ['fishTypes'] }),
    invalidateFishTypesList: () => qc.invalidateQueries({ queryKey: ['fishTypesList'] }),
    invalidateLengthUnits: () => qc.invalidateQueries({ queryKey: ['lengthUnits'] }),
    invalidateWeightUnits: () => qc.invalidateQueries({ queryKey: ['weightUnits'] }),
    invalidateDashboardSuper: () => qc.invalidateQueries({ queryKey: ['dashboard', 'super'] }),
    invalidateDashboardOwner: (fisherId) =>
      qc.invalidateQueries({ queryKey: ['dashboard', 'owner', fisherId] }),
    invalidatePond: (pondId) => qc.invalidateQueries({ queryKey: ['pond', pondId] }),
    invalidatePonds: () => qc.invalidateQueries({ queryKey: ['ponds'] }),
  };
}
